import { render, staticRenderFns } from "./LoadUserPreferencesButton.vue?vue&type=template&id=ae1c2ab4"
import script from "./LoadUserPreferencesButton.vue?vue&type=script&lang=js"
export * from "./LoadUserPreferencesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports